/**
 * The screen code in the build stripe (Matt, 2026-10-23; production builds too, for as long as the stripe stays): only the
 * code (S01, S17·c, …), a small low-contrast badge in the stripe's end corner, hidden from screen readers. No report
 * button and no other beta aid in production (those stay behind `__BETA__` in aids.ts, which imports `badge` from here).
 * Its styles are injected here, not in the app's stylesheet.
 */
import { screenCode, suffixOf, type ScreenKey } from './screenCodes';

const CSS = `
.build-stripe.has-screen-code{position:relative;padding-inline:3rem}
.screen-code{font:400 var(--text-xs)/1.2 var(--mono);letter-spacing:.02em;white-space:nowrap;user-select:all}
.build-stripe .screen-code{position:absolute;inset-inline-end:var(--s3);inset-block-start:50%;transform:translateY(-50%)}
`;

export function ensureStripeStyles(): void {
  if (document.getElementById('stripe-code-css')) return;
  const style = document.createElement('style');
  style.id = 'stripe-code-css';
  style.textContent = CSS;
  document.head.append(style);
}

export function badge(code: string): HTMLElement {
  const b = document.createElement('span');
  b.className = 'screen-code';
  b.setAttribute('aria-hidden', 'true');
  b.dataset.screenCode = code;
  b.textContent = code;
  return b;
}

/** Production: only the code, in the stripe (nothing is added when the page has no stripe). */
export function markStripeCode(root: HTMLElement, key: ScreenKey): void {
  const stripe = root.querySelector('.build-stripe');
  if (!stripe) return;
  ensureStripeStyles();
  stripe.classList.add('has-screen-code');
  stripe.append(badge(screenCode(key, suffixOf(root.querySelector('main') ?? root))));
}
